<template>
  <mi-dialog
    :model-value="saveCollectionModal"
    :custom-design-dialog="true"
    no-backdrop-dismiss
  >
    <div class="collections-dialog">
      <div>
        <div>
          <div class="collections-header-wrapper">
            <h3 class="q-mt-none q-mb-lg collections-header"> {{ isEdit ?'Edit Name': 'New Collection' }} </h3>
            <div class="collections-close-icon">
              <mi-btn
                icon="close"
                icon-type
                icon-size="21px"
                fab
                flat
                @click="handleCloseModal"
              ></mi-btn>
            </div>
          </div>
        </div>
        <div>
          <mi-text-field
            v-model="collectionName"
            label="Collection name"
            placeholder="Add a name to identify"
            :error="error.status"
            :error-message="error.message"
            outlined
            required
          >
          </mi-text-field>
        </div>
      </div>

      <div class="collections-btns-wrapper">
        <mi-btn flat @click="handleCloseModal"> Cancel </mi-btn>

        <mi-btn class="collections-btn-save" @click="onSubmit(collectionName)">
          <man-spinner
            v-if="saveCollectionsLoading"
            variant="accent"
            size="s"
          ></man-spinner>
          <span v-else>
            {{ isEdit ? 'Save' : 'Save Collection' }}
          </span>
        </mi-btn>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  import { ref, watch } from 'vue'
  import MiDialog from '@/packages/@mi-library/MiDialog/MiDialog.vue'
  import { maxLength, required } from '@/utils/validators'

  export default {
    name: 'SavedCollectionDialog',
    components: { MiDialog },
    props: {
      saveCollectionModal: {
        type: Boolean,
        required: false,
        default: false
      },
      collectionNameToBeEdit: {
        type: String,
        required: false,
        default: ''
      },
      handleCloseModal: {
        type: Function,
        required: true,
        default: () => {}
      },
      handleSubmit: {
        type: Function,
        required: true,
        default: () => {}
      },
      saveCollectionsLoading: {
        type: Boolean,
        required: false
      },
      shouldReset: {
        type: Boolean,
        default: false
      },
      isEdit: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    setup(props) {
      const collectionName = ref('')
      const saveCollectionRules = [
        required,
        maxLength(100, 'Max 100 characteres limit.')
      ]
      const error = ref({
        status: false,
        message: ''
      })

      const onSubmit = name => {
        if (name.length === 0) {
          error.value.status = true
          error.value.message = 'Mandatory field'
          return
        }

        if (name.length > 100) {
          error.value.status = true
          error.value.message = 'Max 100 characteres limit.'
          return
        }

        props.handleSubmit(name)
      }

      watch(() => props.shouldReset, () => {
        collectionName.value = ''
        error.value.status = false
        error.value.message = ''
      })

      watch(() => props.collectionNameToBeEdit, () => {
        collectionName.value = props.collectionNameToBeEdit || ''
      })

      return {
        collectionName,
        saveCollectionRules,
        onSubmit,
        error
      }
    }
  }
</script>

<style lang="scss" >
  .collections-dialog {
    width: 475px;
    height: 280px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .collections-header-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .collections-btns-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .collections-btn-save {
    min-width: 156px;
  }
</style>
